<template>
  <div class="balance-view">
    <div class="balance">
      <b>
        <RecyCoinIcon class="recycoin-icon" />
        {{ this.balance }}
      </b>
    </div>
    <div v-if="loading" class="bottom gray-text">
      {{ $t('loading') }}
    </div>
    <div v-else-if="transactions && transactions.length > 0" class="bottom transactions">
      <Transaction v-for="({ uuid, createdAt, quantity, product, reward, station }) in transactions" :key="`transaction.${uuid}`" :date="createdAt" :amount="quantity" :type="product.name" :delta="reward" :place="station.name" />
    </div>
    <div v-else-if="transactions && transactions.length === 0" class="bottom gray-text">
      {{ $t('no-transactions-found.0') }}<router-link :to="{ name: 'stations' }">{{ $t('no-transactions-found.1') }}</router-link>{{ $t('no-transactions-found.2') }}
    </div>
    <div v-else class="bottom gray-text">{{ $t('failed-to-get-transactions') }}</div>
  </div>
</template>

<i18n>
  {
    "es": {
      "loading": "Cargando...",
      "no-transactions-found": {
        "0": "No hay transacciones a tu nombre. Para comenzar andá una de las ",
        "1": "estaciones Recyco",
        "2": "."
      },
      "failed-to-get-transactions": "😢 Se produjo un error intentando conseguir tus transacciones. Por favor recargue la aplicación y si el problema persiste, intente nuevamente más tarde."
    },
    "en": {
      "loading": "Loading...",
      "no-transactions-found": {
        "0": "There are no transactions to your name. To begin go to the one of the ",
        "1": "Recyco stations",
        "2": "."
      },
      "failed-to-get-transactions": "😢 An error ocurred while retrieving your transactions. Please reload the app and if the problem persists, try again later."
    }
  }
</i18n>

<script>
  import gql from 'graphql-tag';

  import { RecyCoinIcon } from '@/components/recyco';
  import Transaction from '@/components/Transaction.vue';

  export default {
    name: 'balance-view',
    components: {
      RecyCoinIcon,
      Transaction,
    },
    data() {
      return {
        rawTransactions: undefined,
      };
    },
    apollo: {
      rawTransactions: {
        query: gql`query me {
          me {
            id
            transactions {
              uuid
              items {
                uuid
                quantity
                product {
                  name
                  material
                }
                reward
              }
              station {
                uuid
                name
              }
              createdAt
            }
          }
        }`,
        update: ({ me }) => me
          .transactions.map((t) => ({
            ...t,
            createdAt: t.createdAt ? new Date(t.createdAt) : undefined,
          })),
        fetchPolicy: 'cache-and-network',
      },
    },
    computed: {
      loading() {
        return this.$apollo.queries.rawTransactions.loading;
      },
      transactions() {
        if (!this.rawTransactions) return undefined;
        const transactions = [];
        for (let i = 0; i < this.rawTransactions.length; i += 1) {
          const transaction = this.rawTransactions[i];
          for (let j = 0; j < transaction.items.length; j += 1) {
            const {
              uuid,
              quantity,
              reward,
              product,
            } = transaction.items[j];
            transactions.push({
              uuid,
              quantity,
              reward,
              product,
              station: transaction.station,
              createdAt: transaction.createdAt,
            });
          }
        }
        return transactions.sort((a, b) => b.createdAt - a.createdAt);
      },
      balance() {
        return this.transactions ? this.transactions.reduce((balance, { reward }) => balance + reward, 0) : undefined;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .balance-view {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .balance {
    font-size: 4em;
    background-color: var(--color-primary);
    color: var(--color-text-light);
    @include drop-shadow();

    text-align: center;
  }

  .recycoin-icon {
    font-size: 0.9em;
  }

  .bottom {
    flex-grow: 1;

    padding: 1em;
  }

  .transactions {
    @include separate-children('vertical', 0.5em);

    overflow-y: scroll;
  }

  .gray-text {
    text-align: center;
    font-size: 2rem;
    font-weight: 900;
    color: #bbbbbb;
  }
</style>
